function LimitPage() {
  return <h1>ขออภัยในความไม่สะดวก ขณะนี้มีผู้ใช้งานระบบจำนวนมาก กรุณารอสักครู่ก่อนเข้าใช้งานอีกครั้ง</h1>;
}

export default LimitPage;
